import React from "react";
import TtIcon from "./icons/domino/tt_icon";

const Tt = ({item, ttpos, lcs}) => {
    return (
        <TtIcon item={item} ttpos={ttpos} lcs={lcs}/>
    )
}

export default Tt